import { Field } from "formik";
import React from "react";
import VStack from "../layout/VStack/VStack";

const DateInput = ({
  label,
  name,
  minDate,
  maxDate,
  format = "dd/mm/yyyy",
  required,
  errorMessage,
}) => {
  return (
    <VStack gap={7}>
      <label className="tText">
        {label}
        <span style={{ color: "red" }}>{required ? "*" : ""}</span>
      </label>
      <Field
        type="date"
        name={name}
        min={minDate}
        defaultValue={minDate}
        max={maxDate}
        format={format}
      />
      {errorMessage && <div className="error">{errorMessage}</div>}
    </VStack>
  );
};

export default DateInput;
